import {
    API_DEPARTMENT_LIST,
    API_DEPARTMENT_DELETE,
    API_DEPARTMENT_DETAIL,
    API_DEPARTMENT_SAVE,
    API_DEPARTMENT_TREE_LIST,
    API_DEPARTMENT_TREE_DRAG,
    API_ORG_TREE
} from '@/common/constants';
import {
    get,
    post,
    del,
    put
} from '@/utils/http';

export const getDepartmentList = (params = { currentPage: 1, pageSize: 10 }) => {
    return get(API_DEPARTMENT_LIST, params);
};
export const getDepartmentTreeList = (rootId) => {
    return get(API_DEPARTMENT_TREE_LIST, rootId ? { rootId } : {});
};

export const getDepartmentDetail = (departmentId) => {
    return get(API_DEPARTMENT_DETAIL.replace(':departmentId', departmentId));
};

export const delDepartment = (departmentId) => {
    return del(API_DEPARTMENT_DELETE.replace(':departmentId', departmentId));
};

export const saveDepartment = (department) => {
    if (department.id === undefined || department.id === '') { // 新增
        return post(API_DEPARTMENT_SAVE, department);
    } else { // 修改
        return put(API_DEPARTMENT_SAVE, department);
    }
};

export const updDepartment = (department) => {
    return put(API_DEPARTMENT_SAVE, department);
};

export const dragDepartmentTreeNode = (draggingNodeId, dropNodeId, type) => {
    return post(API_DEPARTMENT_TREE_DRAG, { draggingNodeId, dropNodeId, type });
};
export const getOrgTreeList=()=>{
     return get(API_ORG_TREE);
};



// WEBPACK FOOTER //
// ./src/data-model/system/department-model.js